import React, { useEffect } from 'react';
import Prefixer from 'inline-style-prefixer';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import FlatButtonLabel from 'material-ui/FlatButton';
import LogoSymbol from '../common/Icons/LogoSymbol';
import fonts from '../../../styles/fonts';
import { isiOS } from '../../../utils/device';
import * as TEXT from '../../../constants/texts';

const MobileView = (props) => {
  const styles = new Prefixer().prefix({
    background: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 110,
      backgroundColor: colors.purple,
    },
    title: {
      fontSize: 26,
      color: 'white',
      lineHeight: '36px',
    },
    text: {
      ...fonts.light,
      fontSize: 16,
      lineHeight: '22px',
      color: 'white',
    },
    buttonWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    button: {
      marginTop: 30,
      display: 'inline-block',
      backgroundColor: 'white',
      color: 'black',
    },
  });

  const openStore = () => {
    if (isiOS()) {
      window.open(
        'https://itunes.apple.com/us/app/ublend/id909131134?mt=8',
        'download_window'
      );
    } else {
      window.open(
        'https://play.google.com/store/apps/details?id=com.ublendreact',
        'download_window'
      );
    }
  };

  const buttonText = () => {
    if (isiOS()) {
      return 'App Store';
    }
    return 'Play Store';
  };

  const updateDocumentTitle = () => {
    document.title = 'Download our app - Aula';
  };
  useEffect(updateDocumentTitle);

  return (
    <div style={styles.background}>
      <LogoSymbol
        style={{
          position: 'absolute',
          top: 40,
          left: 40,
          fontSize: '120px',
        }}
      />
      <p style={styles.title}>{TEXT.MOBILE_TITLE}</p>
      <p style={styles.text}>
        <b>
          {TEXT.MOBILE_TEXT_1}
          <br />
        </b>
        {TEXT.MOBILE_TEXT_2}
        <b>iPhone</b> and <b>Android</b>.
      </p>
      <div style={styles.buttonWrapper}>
        <FlatButtonLabel
          onClick={openStore}
          label={buttonText()}
          primary
          labelStyle={{ textTransform: 'none' }}
          style={styles.button}
        />
      </div>
    </div>
  );
};

export default MobileView;
